// extracted by mini-css-extract-plugin
module.exports = {"table":"SimpleTable_table__4OYUs","headfullTable":"SimpleTable_headfullTable__C0SPo","headlessTable":"SimpleTable_headlessTable__9PA6_"};